export default __webpack_public_path__ + "static/media/commercial-photography.ee1c7997.jpg";